import { Icons } from "../components/Icons";

export const features = [
  {
    key: 1,
    icon: <Icons.Shield />,
    title: "Security, from start to finish",
    text: "Our fleet is regularly updated with the latest models from top manufacturers, ensuring that you're driving a safe and reliable vehicle.",
  },
  {
    key: 2,
    icon: <Icons.Leaf />,
    title: "We are supporting initiatives that promote energy efficiency",
    text: "We are committed to reducing our carbon footprint through investment in clean technologies and contributing to environmental projects.",
  },
  {
    key: 3,
    icon: <Icons.Medal />,
    title: "Awarded for America's Best Customer Service 2022",
    text: "We are committed to providing you with a unique and satisfactory rental experience. We offer a wide variety of rental options and a large selection of vehicles, as well as competitive rates.",
  },
  {
    key: 4,
    icon: <Icons.Globe />,
    title: "20,000 Pickup Locations Worldwide",
    text: "With our easy-to-use online booking system, you can reserve your car in minutes and have it delivered to your doorstep or at the airport.",
  },
  {
    key: 5,
    icon: <Icons.Phone />,
    title: "iOS App",
    text: "Compare prices, make vehicle reservations and more wherever you are.",
  },
  {
    key: 6,
    icon: <Icons.Help />,
    title: "24/7 Road Assistence",
    text: "Our friendly customer service team is always available to assist you with any questions or concerns.",
  },
];
